import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, money } from "../lib/api";
import { useCart } from "../context/CartContext";

const CATS = [["all", "All"], ["device", "Devices"], ["program", "Programs"], ["coaching", "Coaching"], ["supplement", "Supplements"]];

export const ProductCard = ({ p }) => {
  const { add } = useCart();
  return (
    <div data-testid={`product-card-${p.id}`} className="lift bg-white rounded-2xl border border-[#E4DFD4] overflow-hidden flex flex-col">
      <Link to={`/shop/${p.id}`} className="block aspect-[4/3] bg-[#EFECE5] overflow-hidden">
        <img src={p.images[0]} alt={p.name} className="w-full h-full object-cover hover:scale-[1.03] transition-transform duration-500" />
      </Link>
      <div className="p-6 flex flex-col flex-1">
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#0D9488]">{p.badge}</span>
        <Link to={`/shop/${p.id}`} data-testid={`product-link-${p.id}`} className="font-display text-lg font-semibold mt-2 leading-snug hover:text-[#0D9488] transition-colors">{p.name}</Link>
        <p className="text-sm text-slate-600 mt-2 flex-1">{p.short}</p>
        <div className="mt-5 flex items-center justify-between">
          <span className="font-mono text-lg font-bold">{money(p.price)}</span>
          <button data-testid={`add-to-cart-btn-${p.id}`} onClick={() => add(p)} className="rounded-full bg-[#0B1013] hover:bg-[#0D9488] text-white text-sm px-5 py-2.5 font-semibold transition-colors">Add to cart</button>
        </div>
      </div>
    </div>
  );
};

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState("all");
  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)); }, []);
  const shown = cat === "all" ? products : products.filter((p) => p.category === cat);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14" data-testid="shop-page">
      <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#0D9488]">CuraWaves shop</span>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold mt-3">Wave Therapy device, wellness products and services</h1>
      <p className="text-slate-600 mt-4 max-w-2xl">Every device includes free AI-powered personalized planning at WaveTherapy.ai and a 3-year manufacturer warranty.</p>
      <div className="mt-10 flex flex-wrap gap-2">
        {CATS.map(([k, l]) => (
          <button key={k} data-testid={`shop-filter-${k}`} onClick={() => setCat(k)} className={`rounded-full px-4 py-2 text-sm border transition-colors ${cat === k ? "bg-[#0B1013] text-white border-[#0B1013]" : "bg-white border-[#E4DFD4] hover:border-[#0D9488]"}`}>{l}</button>
        ))}
      </div>
      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {shown.map((p) => <ProductCard key={p.id} p={p} />)}
      </div>
    </div>
  );
}
